import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FaDollarSign } from "react-icons/fa";
import cn from "classnames";

import { Page } from "ui/components";
import { Leg } from "services/action";

import epod from "ui/assets/epod.png";
import Input from "ui/components/form/input";

const CollectScreen = ({ match, location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);
  const session = useSelector((state) => state?.Auth?.session);

  const [data, setData] = React.useState(null);
  const [cod, setCod] = React.useState();

  const $onLoad = async (manifestID, legID) => {
    const req = await Dispatch(Leg.$show(manifestID, legID));

    if (req?.message === "success") {
      setData(req?.data);
      setCod(req?.data?.cod_value)
    }
  };

  const $onRecord = async (e) => {
    let payload = {
      actor_name: session?.name,
      actor_phone: session?.phone,
      cod_receive: cod,
    };

    const req = await Dispatch(
      Leg.$collected(location?.state?.manifest_id, data?.id, payload)
    );

    if (req?.message === "success") {
      History.goBack();
    }
  };

  React.useEffect(() => {
    if (match?.params?.id && location?.state?.manifest_id) {
      $onLoad(location?.state?.manifest_id, match?.params?.id);
    }
  }, [match, location]);

  return (
    <Page
      title={<img src={epod} alt="" height={25} />}
      backTo={() => History.goBack()}
      full
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100 fs-7",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onRecord}
            disabled={StateForm?.loading}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        <div>COD Diterima:</div>
        <div className="form-group mv-3">
          <Input
            icon={<FaDollarSign />}
            value={cod}
            onChange={(e) => {
              setCod(e.target.valueAsNumber);
            }}
            type="number"
            placeholder="masukkan nilai cod diterima"
            error={StateForm?.errors?.cod_receive}
            lg
          />
        </div>
      </div>
    </Page>
  );
};

export default CollectScreen;
